import { useState, useEffect } from "react";
import { FaEye, FaUser, FaPlus } from "react-icons/fa";
import { utils, writeFile } from "xlsx";
import axios from "axios";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
} from "reactstrap";

export default function Manuplanlist() {
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const usersPerPage = 10;

    const [plans, setPlans] = useState([]);
    const [plansLoading, setPlansLoading] = useState(false);
    const [addPlanModalOpen, setAddPlanModalOpen] = useState(false);
    const [planUserTarget, setPlanUserTarget] = useState(null);
    const [selectedPlanId, setSelectedPlanId] = useState("");
    const [assigning, setAssigning] = useState(false);
    const [assignError, setAssignError] = useState("");

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = () => {
        axios
            .get("https://api.editezy.com/api/admin/getallusers")
            .then((res) => {
                if (res.data && res.data.users) {
                    setUsers(res.data.users.reverse());
                }
            })
            .catch((error) => {
                console.error("Error fetching users:", error);
            });
    };

    const fetchPlans = () => {
        setPlansLoading(true);
        axios
            .get("https://api.editezy.com/api/plans/getallplan")
            .then((res) => {
                if (res.data && res.data.plans) {
                    setPlans(res.data.plans);
                }
            })
            .catch((error) => {
                console.error("Error fetching plans:", error);
            })
            .finally(() => setPlansLoading(false));
    };

    const handleView = (user) => {
        setSelectedUser(user);
        setViewModalOpen(true);
    };

    const handleOpenAddPlan = (user) => {
        setPlanUserTarget(user);
        setSelectedPlanId("");
        setAssignError("");
        setAddPlanModalOpen(true);
        if (plans.length === 0) {
            fetchPlans();
        }
    };

    const handleAssignPlan = async () => {
        if (!selectedPlanId || !planUserTarget) return;
        setAssigning(true);
        setAssignError("");
        try {
            const res = await axios.post("https://api.editezy.com/api/users/activateplan", {
                userId: planUserTarget.id,
                planId: selectedPlanId
            });
            setAddPlanModalOpen(false);
            alert(res.data?.message || "Plan activated successfully");
        } catch (error) {
            console.error("Error assigning plan:", error);
            setAssignError(
                error?.response?.data?.message || "Failed to assign plan. Please try again."
            );
        } finally {
            setAssigning(false);
        }
    };

    const exportData = (type) => {
        const exportUsers = filteredUsers.map((user, index) => ({
            "Sl No": index + 1,
            Name: user.name || "N/A",
            Email: user.email || "N/A",
            Mobile: user.mobile || "N/A",
            "Profile Image": user.profileImage || "N/A",
            "Created At": user.createdAt || "N/A"
        }));
        const ws = utils.json_to_sheet(exportUsers);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Users");
        writeFile(wb, `users.${type}`);
    };

    const filteredUsers = users.filter((user) =>
        (user.name || "").toLowerCase().includes(search.toLowerCase()) ||
        (user.email || "").toLowerCase().includes(search.toLowerCase()) ||
        (user.mobile || "").toLowerCase().includes(search.toLowerCase())
    );

    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
    const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

    return (
        <>
            <div className="p-4 border rounded-lg shadow-lg bg-white">
                <div className="flex justify-between items-center mb-4">
                    <div>
                        <h2 className="text-xl font-semibold text-blue-900">All Users</h2>
                        <p className="text-muted small">Total Users: {users.length}</p>
                    </div>
                </div>

                <div className="flex justify-between mb-4">
                    <input
                        className="w-1/3 p-2 border rounded"
                        placeholder="Search by name, email or mobile..."
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setCurrentPage(1);
                        }}
                    />
                    <div className="flex gap-2">
                        <button className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300" onClick={() => exportData("csv")}>
                            CSV
                        </button>
                        <button className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300" onClick={() => exportData("xlsx")}>
                            Excel
                        </button>
                    </div>
                </div>

                <div className="overflow-x-auto mb-4">
                    <table className="w-full border-collapse border border-gray-300">
                        <thead>
                            <tr className="bg-purple-600 text-white">
                                <th className="p-2 border">Sl</th>
                                <th className="p-2 border">Profile</th>
                                <th className="p-2 border">Name</th>
                                <th className="p-2 border">Email</th>
                                <th className="p-2 border">Mobile</th>
                                <th className="p-2 border">Joined On</th>
                                <th className="p-2 border">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentUsers.map((user, index) => (
                                <tr key={user.id} className="border-b hover:bg-gray-50">
                                    <td className="p-2 border text-center">{index + 1 + indexOfFirstUser}</td>
                                    <td className="p-2 border text-center">
                                        {user?.profileImage && user.profileImage !== "default-profile-image.jpg" ? (
                                            <img
                                                src={user.profileImage}
                                                alt={user?.name || "User"}
                                                className="w-10 h-10 rounded-full object-cover cursor-pointer"
                                                onClick={() => handleView(user)}
                                                onError={(e) => {
                                                    e.currentTarget.style.display = "none";
                                                    e.currentTarget.nextSibling.style.display = "flex";
                                                }}
                                            />
                                        ) : null}

                                        <div
                                            className={`w-10 h-10 rounded-full bg-blue-500 text-white flex items-center justify-center cursor-pointer mx-auto font-semibold ${user?.profileImage && user.profileImage !== "default-profile-image.jpg" ? "hidden" : "flex"
                                                }`}
                                            onClick={() => handleView(user)}
                                        >
                                            {user?.name?.charAt(0)?.toUpperCase() || <FaUser />}
                                        </div>
                                    </td>
                                    <td className="p-2 border font-medium">{user.name || "N/A"}</td>
                                    <td className="p-2 border">{user.email || "N/A"}</td>
                                    <td className="p-2 border">{user.mobile || "N/A"}</td>
                                    <td className="p-2 border">
                                        {user.createdAt ? new Date(user.createdAt).toLocaleDateString() : "N/A"}
                                    </td>
                                    <td className="p-2 border text-center">
                                        <div className="flex justify-center gap-2">

                                            <button
                                                className="bg-green-600 text-white px-3 py-2 rounded hover:bg-green-700 flex items-center gap-1"
                                                onClick={() => handleOpenAddPlan(user)}
                                                title="Add Plan"
                                            >
                                                <FaPlus /> Add Plan
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {currentUsers.length === 0 && (
                                <tr>
                                    <td className="p-4 border text-center text-muted" colSpan={7}>
                                        No users found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="flex justify-between items-center mt-4">
                        <div className="text-muted small">
                            Showing {indexOfFirstUser + 1} to {Math.min(indexOfLastUser, filteredUsers.length)} of {filteredUsers.length} users
                        </div>
                        <div className="flex gap-2">
                            <button
                                onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}
                                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:opacity-50"
                                disabled={currentPage === 1}
                            >
                                Previous
                            </button>
                            <span className="px-4 py-2 bg-gray-100 rounded">
                                Page {currentPage} of {totalPages}
                            </span>
                            <button
                                onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages))}
                                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:opacity-50"
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* View User Modal */}
            <Modal isOpen={viewModalOpen} toggle={() => setViewModalOpen(false)} size="md" centered>
                <ModalHeader toggle={() => setViewModalOpen(false)} className="bg-primary text-white">
                    User Details
                </ModalHeader>
                <ModalBody>
                    {selectedUser && (
                        <div className="p-3">
                            <div className="text-center mb-4">
                                {selectedUser?.profileImage && selectedUser.profileImage !== "default-profile-image.jpg" ? (
                                    <img
                                        src={selectedUser.profileImage}
                                        alt={selectedUser.name}
                                        className="w-32 h-32 rounded-full object-cover mx-auto border-4 border-primary"
                                        onError={(e) => {
                                            e.currentTarget.style.display = "none";
                                            e.currentTarget.nextSibling.style.display = "flex";
                                        }}
                                    />
                                ) : null}

                                <div
                                    className={`w-32 h-32 rounded-full bg-primary text-white flex items-center justify-center mx-auto border-4 border-primary text-5xl font-bold ${selectedUser?.profileImage && selectedUser.profileImage !== "default-profile-image.jpg" ? "hidden" : "flex"
                                        }`}
                                >
                                    {selectedUser?.name?.charAt(0)?.toUpperCase() || <FaUser size={48} />}
                                </div>
                                <h3 className="mt-3 mb-1 font-bold text-xl">{selectedUser.name || "N/A"}</h3>
                            </div>

                            <div className="border-t pt-4">
                                <div className="space-y-3">
                                    <div>
                                        <label className="text-muted small d-block">User ID</label>
                                        <p className="font-mono text-sm bg-gray-50 p-2 rounded">{selectedUser.id}</p>
                                    </div>
                                    <div>
                                        <label className="text-muted small d-block">Email</label>
                                        <p className="bg-gray-50 p-2 rounded">{selectedUser.email || "N/A"}</p>
                                    </div>
                                    <div>
                                        <label className="text-muted small d-block">Mobile Number</label>
                                        <p className="bg-gray-50 p-2 rounded">{selectedUser.mobile || "N/A"}</p>
                                    </div>
                                    <div>
                                        <label className="text-muted small d-block">Joined On</label>
                                        <p className="bg-gray-50 p-2 rounded">
                                            {selectedUser.createdAt ? new Date(selectedUser.createdAt).toLocaleString() : "N/A"}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setViewModalOpen(false)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Add Plan Modal */}
            <Modal isOpen={addPlanModalOpen} toggle={() => setAddPlanModalOpen(false)} size="md" centered>
                <ModalHeader toggle={() => setAddPlanModalOpen(false)} className="bg-primary text-white">
                    Add Plan {planUserTarget ? `for ${planUserTarget.name || planUserTarget.mobile || ""}` : ""}
                </ModalHeader>
                <ModalBody>
                    {planUserTarget && (
                        <p className="text-muted small mb-3">
                            User ID: <span className="font-mono">{planUserTarget.id}</span>
                        </p>
                    )}

                    {plansLoading && <p className="text-center text-muted py-3">Loading plans...</p>}

                    {!plansLoading && plans.length === 0 && (
                        <p className="text-center text-muted py-3">No plans available.</p>
                    )}

                    {!plansLoading && plans.length > 0 && (
                        <div className="space-y-2">
                            {plans.map((plan) => (
                                <label
                                    key={plan._id}
                                    className={`d-flex align-items-start gap-2 p-3 border rounded cursor-pointer ${selectedPlanId === plan._id ? "border-primary bg-light" : ""
                                        }`}
                                    style={{ cursor: "pointer" }}
                                >
                                    <input
                                        type="radio"
                                        name="plan"
                                        value={plan._id}
                                        checked={selectedPlanId === plan._id}
                                        onChange={() => setSelectedPlanId(plan._id)}
                                        className="mt-1"
                                    />
                                    <div>
                                        <div className="fw-bold">{plan.name}</div>
                                        <div className="small text-muted">
                                            ₹{plan.offerPrice} <s className="text-muted">₹{plan.originalPrice}</s>{" "}
                                            ({plan.discountPercentage}% off) &middot; {plan.duration}
                                        </div>
                                    </div>
                                </label>
                            ))}
                        </div>
                    )}

                    {assignError && <p className="text-danger small mt-3 mb-0">{assignError}</p>}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setAddPlanModalOpen(false)}>
                        Cancel
                    </Button>
                    <Button color="success" disabled={!selectedPlanId || assigning} onClick={handleAssignPlan}>
                        {assigning ? "Assigning..." : "Submit"}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}
